import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { BrandCarousel } from "@/components/site/BrandCarousel";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Pricing } from "@/components/site/Pricing";
import { FaccetteTeaser } from "@/components/site/FaccetteTeaser";
import { BoneSection } from "@/components/site/BoneSection";
import { Doctors } from "@/components/site/Doctors";
import { Collaboratori } from "@/components/site/Collaboratori";
import { Gallery } from "@/components/site/Gallery";
import { Network } from "@/components/site/Network";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { TollFree } from "@/components/site/TollFree";
import { Testimonials } from "@/components/site/Testimonials";
import { VideoTestimonials } from "@/components/site/VideoTestimonials";
import { VideoPills } from "@/components/site/VideoPills";
import { BlogTeaser } from "@/components/site/BlogTeaser";
import { Faq } from "@/components/site/Faq";
import { ContactSection } from "@/components/site/ContactSection";
import { Footer } from "@/components/site/Footer";
import { LegalNote } from "@/components/site/LegalNote";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta(
    "Impianti dentali a carico immediato: denti fissi in 6 ore, costi chiari | Dentista Sostenibile",
    "Quanto costano gli impianti dentali? Implantologia a carico immediato All on 4 a €4.900 per arcata tutto incluso, denti fissi in 6 ore se le condizioni cliniche lo consentono, garanzia economica 10 anni. 8 studi dentistici convenzionati in provincia di Milano e di Monza Brianza, Novara, Chivasso (TO), Seriate (Bergamo) e Palermo. Prima visita con TAC senza impegno."
  );
  return (
    <main className="bg-[#EAF4F8]">
      <Header />
      <Hero />
      <EditorialMarquee />
      <HowItWorks />
      <Pricing />
      <div className="px-6 md:px-12 bg-[#EAF4F8]">
        <div className="max-w-7xl mx-auto">
          <LegalNote />
        </div>
      </div>
      <FaccetteTeaser />
      <Doctors />
      <Collaboratori />
      <BrandCarousel />
      <BoneSection />
      <Gallery />
      <Network />
      <BeforeAfter />
      <TollFree />
      <Testimonials />
      <VideoTestimonials />
      <VideoPills />
      <BlogTeaser />
      <Faq />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
